import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from "mobx-react"
import { Button } from 'react-bootstrap'
import FaIcon from '../../../helpers/fa_icon.js'

const PrintForm = ({ store }) => {
  const [isPrinting, setIsPrinting] = useState(false)

  const handlePrintForm = () => {
    setIsPrinting(true)
    store.persistFormContent(() => window.location = "?format=pdf&autoprint=true&printable=true")
  }

  if(store.printable || store.mode === "preview" || store.mode === "build") {
    return null
  } else if(store.editable) {
    return (
      <Button
        className="w-100"
        size="lg"
        variant="outline-secondary"
        onClick={handlePrintForm}
        disabled={isPrinting}
      >
        <FaIcon
          icon={isPrinting ? "spinner" : "print"}
          spin={isPrinting}
          text={isPrinting ? "Generating printable version..." : "Print"}
        />
      </Button>
    )
  }
  else {
    return null
  }
}

export default inject("store")(observer(PrintForm))
